jQuery(document).ready(function ($) {
    
    var wW = $(window).width();
    
    // collapsible dashboard side menu
    var burger = $('.sidebar .burger-menu');
    var sidenav = $('.dashboard .sidebar');

    burger.on('click', function () {
        sidenav.toggleClass('collapsed');
//        $('body').toggleClass('locked');
    });

    $(window).on('resize', function () {
        var wW = $(window).width();
        if (wW < 992) {
            sidenav.addClass('collapsed');
        } else {
            sidenav.removeClass('collapsed');
        }
    });
    
    sidenav.addClass('has-transition');


    //    initialize tooltips
    $('[data-toggle="tooltip"]').tooltip()

    //show new data form on admin dashboard, show desfasurator leasing

    $('.show-next-section').on("click", function () {
        var sectionToShow = $(this).attr('href');
        if (!sectionToShow){
            var sectionToShow = '#desfasuratorCalculator';
        }else{
            $(this).addClass('hidden');
        }
        $(sectionToShow).addClass("opened");
    });


    $(".bootstrap-file-upload").fileinput({
        'language': 'ro',
        'showUpload': false,
        'showCaption': true,
        'previewFileType': 'false'
    });

    //    add new file upload field

    $(".contul-meu-date-firma #insertInput").on("click", function () {
        var counter = $('#solicitareSchimbareDate .input-line').length + 1;
        initFileUpload('admin', counter);
    });

    $(".contul-meu-date-persoana-fizica #insertInput").on("click", function () {
        var counter = $('#solicitareSchimbareDate .input-line').length + 1;
        initFileUpload('pf', counter);
    });


    //    dashboard navbar toggler
    $(".mobile-toggle").on('click', function () {
        $(this).parents('.navbar').toggleClass('open');
    });

    $(".dashboard-content .navbar .navbar-nav li.active").on('click', function (e) {
        e.preventDefault();
        $(this).parents('.navbar').removeClass('open');
    });

    //    cerere Documente
    $("#cerereDocumente").fileinput({
        'language': 'ro',
        'showUpload': 'false',
        'showCaption': 'true',
        'previewFileType': 'true',
        'browseOnZoneClick': 'true',
        'uploadUrl': 'uploads',
        'showBrowse': 'true'
    });
    $("#facturaProforma").fileinput({
        'language': 'ro',
        'showUpload': 'false',
        'showCaption': 'true',
        'previewFileType': 'true',
        'browseOnZoneClick': 'true',
        'uploadUrl': 'uploads',
        'showBrowse': 'true'
    });
    $("#reclamatieDocumenteModal").fileinput({
        'language': 'ro',
        'showUpload': 'false',
        'showCaption': 'true',
        'previewFileType': 'true',
        'browseOnZoneClick': 'true',
        'uploadUrl': 'uploads',
        'showBrowse': 'true'
    });
    $("#cerereDocumenteModal").fileinput({
        'language': 'ro',
        'showUpload': 'false',
        'showCaption': 'true',
        'previewFileType': 'true',
        'browseOnZoneClick': 'true',
        'uploadUrl': 'uploads',
        'showBrowse': 'true'
    });

    //    aplicatie leasing - date bun - fotografie alt bun
    $("#aplicatieLeasingFotografieAltBun").fileinput({
        'language': 'ro',
        'showUpload': 'false',
        'showCaption': 'true',
        'previewFileType': 'true',
        'browseOnZoneClick': 'true',
        'uploadUrl': 'images',
        'showBrowse': 'true',
    });

    //    aplicatie leasing - date bun - fotografie echipament
    $("#aplicatieLeasingFotografieEchipament").fileinput({
        'language': 'ro',
        'showUpload': 'false',
        'showCaption': 'true',
        'previewFileType': 'true',
        'browseOnZoneClick': 'true',
        'uploadUrl': 'images',
        'showBrowse': 'true',
    });


    //    aplicatie leasing - date bun - fotografie imobil
    $("#aplicatieLeasingFotografieImobil").fileinput({
        'language': 'ro',
        'showUpload': 'false',
        'showCaption': 'true',
        'previewFileType': 'true',
        'browseOnZoneClick': 'true',
        'uploadUrl': 'images',
        'showBrowse': 'true',
    });

    //    aplicatie leasing persoana expusa politic - show hide position

    $(".persoana-politica").on('click', function () {
        var parent = $(this);

        if (parent.find('.radio-yes').is(':checked')) {
            $(parent.attr('data-target')).addClass('opened').find('input').attr('required', true);
        } else {
            $(parent.attr('data-target')).removeClass('opened').find('input').removeAttr('required');
        }

    });

    //    aplicatie leasing beneficiar real - show hide name and cnp

    $(".beneficiar-real").on('click', function () {
        var parent = $(this);

        if (parent.find('.radio-yes').is(':checked')) {
            $(parent.attr('data-target')).removeClass('opened').find('input').removeAttr('required');
        } else {
            $(parent.attr('data-target')).addClass('opened').find('input').attr('required', true);
        }

    });

    //check before submit if persoana - expusa politic and beficiar - real, if it is store value, else remove
    $('input[type="submit"]').on('click', function () {
        var parent_beneficiar = $(".beneficiar-real");
        if (parent_beneficiar.find('.radio-yes').is(':checked')) {
            $("#numeBeneficiarReal").val("");
            $("#cnpBeneficiarReal").val("");
        }

        var parent_persoana = $(".persoana-politica");
        if (!parent_persoana.find('.radio-yes').is(':checked')) {
            $("#functiePolitica").val("");
        }
    });

    //    init charts
    $('.chart').circliful();

    //    show / hide notifications list on mobile toggler click
//    $(".show-hide-notfications").on('click', function () {
//        $('.notifications-list').toggleClass('opened');
//    });


    //    collapase/uncollaspe bunuri dropdown

    $(".management-button").on('click', function () {
        $(".responsive-item").not($(this).parents('.responsive-item')).removeClass('opened');
        $(this).parents('.responsive-item').toggleClass("opened");
        if (wW < 768) {
            $("body").toggleClass("locked");
        }
    });



    function initFileUpload(page, counter) {
        var dataHTML = "<div class='row input-line'><div class='col-xs-12 col-sm-7'><div class='form-group'><input type=''text' class='form-control' id='document-change-" + page + "-" + counter + "' name='document-change-" + page + "-" + counter + "' placeholder='Ce anume doriti sa schimbati'></div></div><div class='col-xs-12 col-sm-5'><div class='form-group'><input id='file-upload-" + page + "-" + counter + "' name='file-upload-" + page + "-" + counter + "' type='file' class='file bootstrap-file-upload' data-show-preview='false'></div></div></div>";

        $("#solicitareSchimbareDate .inserted-inputs").append(dataHTML);

        $("#file-upload-" + page + "-" + counter).fileinput({
            'language': 'ro',
            'showUpload': false,
            'showCaption': true,
            'previewFileType': 'false'
        });

    }

    //    detalii bun automobil, clone service inputs


    function clone() {
        var parentEl = $(this).parents("form").find(".auto-service");
        var clone = parentEl.find(".clone-item:last-of-type").clone();
        clone.appendTo(parentEl);
        clone.on('click', '.clone-add', clone);
        clone.on('click', '.clone-remove', remove);
        clone.find('input').val('');
        clone.find('select').val('notSelected');
        clone.find('.input-datepicker').removeAttr('id').removeClass('hasDatepicker').datepicker({ dateFormat: 'dd-mm-yy' });
    }

    function remove(element) {
        element.parents(".service-list").remove();
    }
    $(document).on("click", ".clone-add", clone);

    $(document).on("click", ".clone-remove", function(){
        if (!$(this).attr('id')) {
            remove($(this));
        }
    });

    // don't permit special characters in phone number
    $('#telefonFirma').on('change keyup', function() {
        var phone_nr = $('#telefonFirma').val();
        var sanitized = $(this).val().replace(/[^0-9]/g, '');
        if (phone_nr.charAt(0) == "+"){
            $(this).val("+" + sanitized);
        } else {
            $(this).val(sanitized);
        }
    });

    // admin vizionare solicitare modals
    $('.admin-view-request .modal').on('hidden.bs.modal', function () {
        var currentButton = $(this).attr('id');
         if ($(this).find('textarea').val().trim().length > 1) {
          $('[data-target="#' + currentButton + '"]').addClass('edited');
         } else {
             $('[data-target="#' + currentButton + '"]').removeClass('edited');
         }
    });

    // init date picker

    $('.input-datepicker').datepicker({ dateFormat: 'dd-mm-yy' });
    
    $('.modal').on('scroll', function(){
//        hideDatepicker();
    });
    
    $(window).on('scroll', function(){
//        hideDatepicker();
    });

    $('.input-datepicker').focusout(function() {
       // hideDatepicker();
    });
    
    function hideDatepicker() {
        if ($("#ui-datepicker-div").length != 0) {
            $(".hasDatepicker").datepicker('hide').blur();    
        }
    }
    
    $('.checkbox-wrapper.input-visible label').on('click', function(){
       if ($(this).find('input').is(':checked')) {
           $(this).addClass('checked');
       } else {
           $(this).removeClass('checked');
       }
    });

    $('.submit-once').on('submit', function(e) {
        $('button[type="submit"]').attr('disabled', true);
    });

});
